module.exports = __webpack_public_path__ + "assets/img/6.c04ad985.png";